import styled from 'styled-components';
import { rem, ellipsis } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../../core/Icon';
import Button from '../../core/Buttons';

const StyledDocuments = styled.div`
  width: 100%;
`;

const StyledDocumentsTitle = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  color: ${props => props.theme.colors.grayDarkest};
  margin-bottom: ${rem('5px')};
`;

const StyledDocumentsList = styled.ul`
  border-top: ${rem('2px')} solid ${props => props.theme.colors.dark};
  border-left: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  border-right: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  padding: 0;
  margin: ${rem('3px')} 0 0 0;
  display: inline-block;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${rem('1px')};
    background-color: ${props => props.theme.colors.grayLighter};
  }
`;

const StyledDocumentsItem = styled.li`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  padding: 0 ${rem('10px')} 0;
  width: 100%;
  display: flex;
  align-items: center;
  &:before {
    display: none;
  }
  ${mediaqueries.greaterThan('mobile')`
    width: 50%;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: 100%;
  `};
`;

const StyledDocumentsDownload = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${rem('8px')} 0;
  cursor: pointer;
`;

const IconDocuments = styled(Icon)`
  min-width: ${rem('36px')};
  max-width: ${rem('36px')};
  height: ${rem('27px')};
  margin-right: ${rem('10px')};
  flex-grow: 2;
`;

const StyledDocumentsName = styled.span`
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.grayDark};
  width: ${ellipsis('98%')};
`;

const StyledCenter = styled.div`
  width: ${rem('80px')};
  margin: ${rem('10px')} auto 0;
`;

const StyledButtonsRight = styled(Button)`
  width: ${rem('34px')};
  height: ${rem('34px')};
  padding: 0;
  margin-top: ${rem('14px')};
  position: static;
  background-color: #ffffff;

  & > svg {
    position: relative;
    left: ${rem('4px')};
  }
  &:hover,
  &:active {
    background-color: #ffffff;
  }
`;

export {
  StyledDocuments,
  StyledDocumentsTitle,
  StyledDocumentsList,
  StyledDocumentsItem,
  StyledDocumentsDownload,
  IconDocuments,
  StyledDocumentsName,
  StyledCenter,
  StyledButtonsRight
};
